export default "__VITE_ASSET__CmQacpMF__"